import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

export interface ITag {
  id: string;
  name: string;
  description?: string;
}

export const tagsApi = createApi({
  reducerPath: 'tagsApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['Tags'],
  keepUnusedDataFor: 3600,
  endpoints: (builder) => ({
    getTags: builder.query<ITag[], void>({
      query: () => ({
        url: '/tags',
        method: 'GET',
      }),
      providesTags: ['Tags'],
      forceRefetch: () => false,
    }),

    createTag: builder.mutation<ITag, Omit<ITag, 'id'>>({
      query: (data) => ({
        url: '/tags',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Tags'],
    }),

    updateTag: builder.mutation<ITag, ITag>({
      query: (data) => ({
        url: '/tags',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Tags'],
    }),

    deleteTag: builder.mutation<void, string>({
      query: (id) => ({
        url: `/tags/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Tags'],
    }),
  }),
});

export const {
  useGetTagsQuery,
  useCreateTagMutation,
  useUpdateTagMutation,
  useDeleteTagMutation,
  useLazyGetTagsQuery
} = tagsApi;
